import { NgModule } from '@angular/core';
import { F8SortByPipe } from './sort-by.pipe';



export class F8SortByPipeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [F8SortByPipe],
  exports: [F8SortByPipe]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
